// Rx.K products are always listed in routine order — Booster, Serum, Cream —
// then the set and the gift box. Sorting by sku or name would put Cream
// before Serum (RXK-CRM50 < RXK-SRM50), so every product list/column uses
// this instead.
const ORDER: RegExp[] = [/booster|-BST/i, /serum|-SRM/i, /cream|-CRM/i, /set/i, /gift/i];

export function productRank(skuOrName: string | null | undefined): number {
  const s = skuOrName ?? '';
  const i = ORDER.findIndex((re) => re.test(s));
  return i === -1 ? ORDER.length : i;
}

/** Sort comparator: pass the sku and/or the product name of each item. */
export function compareProducts(a: { sku?: string | null; name?: string | null }, b: { sku?: string | null; name?: string | null }): number {
  const rank = (p: { sku?: string | null; name?: string | null }) => Math.min(productRank(p.sku), productRank(p.name));
  return rank(a) - rank(b) || (a.name ?? a.sku ?? '').localeCompare(b.name ?? b.sku ?? '');
}

type ProductLike = { sku?: string | null; name_en?: string | null; product_name?: string | null };

/** Sorted copy of rows from core_products / stock views, in product order. */
export function sortProducts<T extends ProductLike>(rows: T[] | null | undefined): T[] {
  const key = (r: T) => ({ sku: r.sku, name: r.name_en ?? r.product_name ?? null });
  return [...(rows ?? [])].sort((a, b) => compareProducts(key(a), key(b)));
}
